import React from "react";
import { NavLink } from "react-router-dom";

const labelStyle = {
  fontSize: "14px",
};

const Register = () => {
  return (
    <section style={{ backgroundColor: "#f1f1f1", height: "100vh" }}>
      <div className="container">
        <div className="logo text-center my-5">
          <NavLink to="/" className="site-ancer">
            <img src="images/logo.png" alt="logo" />
          </NavLink>
        </div>
        <div className="row">
          <div
            className="col-md-5 p-3 m-auto"
            style={{ backgroundColor: "#fff" }}
          >
            <label for="fname" class="form-label" style={labelStyle}>
              First Name
            </label>
            <input
              type="text"
              class="form-control mb-3"
              name="fname"
              required
            />
            <label for="lname" class="form-label" style={labelStyle}>
              Last Name
            </label>
            <input
              type="text"
              class="form-control mb-3"
              name="lname"
              required
            />
            <label for="email" class="form-label" style={labelStyle}>
              Email
            </label>
            <input
              type="text"
              class="form-control mb-3"
              name="email"
              required
            />
            <label for="phone" class="form-label" style={labelStyle}>
              Phone
            </label>
            <input
              type="text"
              class="form-control mb-3"
              name="phone"
              required
            />
            <label for="password" class="form-label" style={labelStyle}>
              Password
            </label>
            <input
              type="password"
              class="form-control mb-3"
              name="password"
              required
            />
            <label for="cpassword" class="form-label" style={labelStyle}>
              Confirm Password
            </label>
            <input
              type="password"
              class="form-control"
              name="cpassword"
              required
            />
            <button
              class="py-1 px-3 my-3 text-white"
              style={{ background: "#008ec2" }}
              type="submit"
              name="register"
            >
              Register
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Register;
